module.exports = __webpack_public_path__ + "img/about_missions_list.a5d8dc0e.png";